import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Home } from "@/pages/Home";
import { Memberships } from "@/pages/Memberships";
import { Trainers } from "@/pages/Trainers";
import { Schedule } from "@/pages/Schedule";
import { Testimonials } from "@/pages/Testimonials";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/membresias" element={<Memberships />} />
          <Route path="/profesores" element={<Trainers />} />
          <Route path="/horarios" element={<Schedule />} />
          <Route path="/testimonios" element={<Testimonials />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
